import styled from 'styled-components';
import { position } from 'polished';
import { fromLarge } from 'styleUtils/mediaQueries';

export const Wrapper = styled.div`
    display: none;

    ${fromLarge`
        ${position('absolute', null, null, '-185px', '25%')}
        display: block;
        z-index: 2;
        margin-left: -81px;
  `}
`;
